// components/Grupos.jsx
import React, { useEffect, useState } from 'react';
import { useGrupos } from './hooks/useGrupos';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { Arrow } from './components/UI/Arrow/Arrow';
import { Badge } from './components/UI/Badge/Badge';
import { Loading } from './components/Loading/Loading';
import { useGruposConfig } from './hooks/useGruposConfig';
import '../css/Filtros.css';
import '../css/Grupos.css';
import { useURLParams } from './hooks/useURLParams';

export const Grupos = ({ visible, toggleGrupos, onGroupSelection }) => {
  if (!visible) return null;
  return (
    <GruposContent
      toggleGrupos={toggleGrupos}
      onGroupSelection={onGroupSelection}
    />
  );
};

const GruposContent = ({ toggleGrupos, onGroupSelection }) => {
  const { data: groupProperties, isLoading, cookies } = useGrupos();
  const { updateGrupos, cleanGrupos, countGrupos } = useGruposConfig(
    cookies?.grupos
  );

  const [groupSelected, setGroupSelected] = useState(null);
  const gruposCount = countGrupos();
  const { updateParms, searchParams } = useURLParams();

  const handleCheckbox = (property) => () => {
    setShowAll(false);

    setSeleccionados((prev) => {
      const newSelecteds = new Map(prev);

      if (newSelecteds.has(property.id)) {
        newSelecteds.delete(property.id);
      } else {
        newSelecteds.set(property.id, {
          id: property.id,
          denomination: property.denomination,
          type: property.type,
        });
      }

      const ids = Array.from(newSelecteds.keys()).join(',');
      updateParms(['grupos', ids || null, 'pagina', 1]);
      updateGrupos(newSelecteds);

      return newSelecteds;
    });
  };

  const handleShowAllToggle = () => {
    const newShowAll = !showAll;
    setShowAll(newShowAll);

    if (newShowAll) {
      const marcas =
        groupProperties?.find((group) => group.type === 'Marca')?.properties ||
        [];

      const allMarcas = new Map(
        marcas.map((marca) => [
          marca.id,
          {
            id: marca.id,
            denomination: marca.denomination,
            type: 'Marca',
          },
        ])
      );

      setSeleccionados(allMarcas);
      updateGrupos(allMarcas);

      const ids = Array.from(allMarcas.keys()).join(',');
      updateParms(['grupos', ids, 'pagina', 1]);

      if (onGroupSelection) onGroupSelection(allMarcas);
    } else {
      setSeleccionados(new Map());
      cleanGrupos();
      updateParms(['grupos', null, 'pagina', 1]);
      if (onGroupSelection) onGroupSelection(new Map());
    }
    window.location.reload();
  };

  const [seleccionados, setSeleccionados] = useState(() => {
    const paramGrupos = searchParams.get('grupos');
    return paramGrupos
      ? new Map(
          paramGrupos
            .split(',')
            .map((id) => [
              Number(id),
              { id: Number(id), denomination: '', type: '' },
            ])
        )
      : new Map();
  });

  useEffect(() => {
    const gruposCookie = cookies.get('grupos');
    if (gruposCookie) {
      try {
        const parsed = new Map(Array.isArray(gruposCookie) ? gruposCookie : []);
        setSeleccionados(parsed);

        if (groupProperties) {
          const marcas =
            groupProperties.find((g) => g.type === 'Marca')?.properties || [];
          const allMarcasSelected =
            marcas.length > 0 && marcas.every((marca) => parsed.has(marca.id));
          setShowAll(allMarcasSelected);
        }
      } catch (e) {
        console.error('Error parsing grupos cookie', e);
      }
    }
  }, [groupProperties]);

  useEffect(() => {
    if (groupProperties) {
      const marcas =
        groupProperties.find((group) => group.type === 'Marca')?.properties ||
        [];
      const allMarcasSelected =
        marcas.length > 0 &&
        marcas.every((marca) => seleccionados.has(marca.id));
      setShowAll(allMarcasSelected);
    }
  }, [seleccionados, groupProperties]);

  const handleCleanGrupos = () => {
    setSeleccionados(new Map());
    setShowAll(false);
    cleanGrupos();
    updateParms(['grupos', null, 'pagina', 1]);
    if (onGroupSelection) onGroupSelection(new Map());
    window.location.reload();
  };

  const [showAll, setShowAll] = useState(false);

  return (
    <div className="filter-list grupos-container">
      <div className="nav__filtros modal-content-global">
        <button
          type="button"
          className="close-button"
          onClick={() => toggleGrupos()}
        >
          <FontAwesomeIcon icon={faXmark} width={24} height={24} />
          <span className="sr-only">Cerrar grupos</span>
        </button>

        {isLoading ? (
          <Loading enabled />
        ) : (
          <div className="filters-container">
            {gruposCount > 0 && (
              <button
                type="button"
                className="clean-filters clean-groups"
                onClick={handleCleanGrupos}
              >
                Borrar grupos aplicados <Badge>{gruposCount}</Badge>
              </button>
            )}

            <div className="groups-section">
              <div className="group-items">
                <div className="group-property all-items-option">
                  <input
                    id="group-all"
                    type="checkbox"
                    checked={showAll}
                    onChange={handleShowAllToggle}
                    className="group-checkbox"
                  />
                  <label htmlFor="group-all" className="group-label">
                    Agrupar
                  </label>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="modal-background" onClick={() => toggleGrupos()}></div>
    </div>
  );
};

export default Grupos;
